import * as React from "react";
import type { SVGProps } from "react";
const SvgPaperAirplane = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m26.189 38.976-5.396-16.31m5.396 16.31 7.971-7.385 6.378 5.178m-14.35 2.207V25.118m-5.395-2.453L10 14.816 62 5.25M20.793 22.665 62 5.25m0 0L40.538 36.769M62 5.25 26.189 25.118m14.349 11.65-14.35-11.65"
    />
    <path
      stroke="#D3ECF8"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="m3 57.25 17-15M24.5 46.25v12.5M14 37.25H2"
    />
  </svg>
);
export default SvgPaperAirplane;
